'use strict';
module.exports = require('./ToastService.js');